import { CollapseType } from '@meitu/saas-editor-ui/es/types';
import { events } from '@/events-bus';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';
import { isIntl, REACT_APP_ENV } from '@/react-process-env';
import { useCollapseModel } from '@/store/collapse-models/collapse-model';
import { useEditorModel } from '@/store/models/editor-model';
import { useRecordModel } from '@/store/models/record-model';
import thumbnailOfEffectText from '../../assets/effect-text-thumbnail.png';
import thumbnailOfShapeTextDark from '../../assets/shape-text-dark-thumbnail.png';
import thumbnailOfShapeTextLight from '../../assets/shape-text-light-thumbnail.png';
import { BlockContainer } from '../../components';
import { Funcs, ScopeEvents } from '../../constants';
import { Tracker } from '../../utils';
import './style.less';

const TextShortcut: React.FC = () => {
    const { $t } = useLocaleStore();

    const theme = useEditorModel((state) => state.theme);
    const setCurrentType = useCollapseModel((state) => state.setCurrentType);
    const recordInfo = useRecordModel((state) => state.recordInfo);

    const openTextCollapse = () => {
        events.emit(ScopeEvents.FuncUse, Funcs.OpenTextPanel);

        Tracker.openTextMaterialCollapse(recordInfo?.id);

        setCurrentType(CollapseType.TEXT_MENU);
    };

    const addDefaultTitle = () => {
        events.emit(ScopeEvents.FuncUse, Funcs.AddTextLayer);
        Tracker.addTextLayerByPreset();
        editor.textLayer.addDefaultTitle();
    };

    const addDefaultSubTitle = () => {
        events.emit(ScopeEvents.FuncUse, Funcs.AddTextLayer);
        Tracker.addTextLayerByPreset();
        editor.textLayer.addDefaultSubTitle();
    };

    const addDefaultContent = () => {
        events.emit(ScopeEvents.FuncUse, Funcs.AddTextLayer);
        Tracker.addTextLayerByPreset();
        editor.textLayer.addDefaultContent();
    };

    const addDefaultShapeText = () => {
        events.emit(ScopeEvents.FuncUse, Funcs.AddTextLayer);
        Tracker.addTextLayerByPreset();

        const materialID =
            REACT_APP_ENV === 'beta' || REACT_APP_ENV === 'release' ? '1701150781645501' : '1699523891681574';

        editor.textLayer.addDefaultShapeText(materialID);
    };

    const addDefaultEffectText = () => {
        events.emit(ScopeEvents.FuncUse, Funcs.AddTextLayer);
        Tracker.addTextLayerByPreset();
        editor.textLayer.addDefaultEffectText();
    };

    return (
        <BlockContainer className="text-shortcut" title={$t((v) => v.collapse.shortcutCollapse.text.menuTitle)}>
            <div className="text-shortcut__btns">
                <div className="shortcut-btn text-shortcut__btn text-shortcut__btn--title" onClick={addDefaultTitle}>
                    {$t((v) => v.collapse.shortcutCollapse.text.title)}
                </div>
                <div
                    className="shortcut-btn text-shortcut__btn text-shortcut__btn--subTitle"
                    onClick={addDefaultSubTitle}
                >
                    {$t((v) => v.collapse.shortcutCollapse.text.subTitle)}
                </div>
                <div
                    className="shortcut-btn text-shortcut__btn text-shortcut__btn--content"
                    onClick={addDefaultContent}
                >
                    {$t((v) => v.collapse.shortcutCollapse.text.text)}
                </div>
            </div>

            {!isIntl ? (
                <div className="text-shortcut__btns">
                    <div
                        className="shortcut-btn text-shortcut__btn text-shortcut__btn--complex"
                        onClick={addDefaultShapeText}
                    >
                        <img
                            draggable={false}
                            src={theme === 'light' ? thumbnailOfShapeTextLight : thumbnailOfShapeTextDark}
                            alt=""
                        />
                    </div>

                    <div
                        className="shortcut-btn text-shortcut__btn text-shortcut__btn--complex"
                        onClick={addDefaultEffectText}
                    >
                        <img draggable={false} src={thumbnailOfEffectText} alt="" />
                    </div>
                </div>
            ) : null}
        </BlockContainer>
    );
};

export default TextShortcut;
